import buildstreaks from "./assets/images/buildstreaks.png"
import campusrecruit from "./assets/images/campusrecruit.jpg"
import EcommerceWebsite from './assets/images/EcommerceWebsite.png'
import ReliableAILandingPage from './assets/images/reliableaiLandingPage.png'
import GoogleKeep from './assets/images/GoogleKeep.png'
import CurriculumDesignPortal from './assets/images/curriculumDesignPortal.png'
import Game2048 from './assets/images/2048Game.png'
import todoList from './assets/images/todoList.png'
import DrumKit from './assets/images/DrumKit.png'
import restaurantWebsite from './assets/images/restaurantWebsite.png'
import bikeRepairWebsite from './assets/images/bikeRepairWebsite.png'
import Calculator from './assets/images/Calculator.png'


const all_projects = [
    {
        img: campusrecruit,
        liveLink: "https://github.com/muskanmandil/campus-recruit",
        title: "Campus Recruit",
        repoLink: "https://github.com/muskanmandil/campus-recruit",
        desc: "(Ongoing) A campus recruitment platform supporting students with a profile system enabling them to apply in 1-click with resume submission.",
        tech: "React.js, Material UI, Node.js, Express.js, PostgreSQL"

    },
    {
        img: buildstreaks,
        liveLink: "https://build-streaks.vercel.app/",
        title: "Build Streaks",
        repoLink: "https://github.com/muskanmandil/build-streaks",
        desc: "A Full stack application gamifying DSA learning experience. Implemented features like gain XPs, streak building and leaderboard.",
        tech: "React.js, Node.js, Express.js, MongoDB, UI/UX Design"

    },
    {
        img: EcommerceWebsite,
        liveLink: "https://shoppers-nine.vercel.app/",
        title: "Shoppers Website",
        repoLink: "https://github.com/muskanmandil/Ecommerce-Website",
        desc: "An Ecommerce Website for clothes. My first full-stack project : Created APIs, Implemented user registration, Managed Database connection",
        tech: "React.js, Express.js, MongoDB"

    },
    {
        img: CurriculumDesignPortal,
        liveLink: "https://bit.ly/curriculum-portal",
        title: "Curriculum Design Portal",
        repoLink: "https://github.com/Dev-Sahani/AICTE_CURRICULUM_DESIGN_PORTAL",
        desc: "Ranked in Top 5 teams in SIH 2023. Contributed as UI/UX Designer. Led design ideation sessions in collaboration with the team.",
        tech: "UI/UX Design, Figma"
    },
    {
        img: GoogleKeep,
        liveLink: "https://muskanmandil.github.io/Google-Keep-Clone",
        title: "Google Keep Clone",
        repoLink: "https://github.com/muskanmandil/Google-Keep-Clone",
        desc: "A replica of Google Keep Notes Application which allow users to create, edit and delete notes, mimicking the features of the original application.",
        tech: "HTML, CSS, Javascript"
    },
    {
        img: Game2048,
        liveLink: "https://muskanmandil.github.io/2048-Game",
        title: "2048 Game",
        repoLink: "https://github.com/muskanmandil/2048-Game",
        desc: "Cloned the famous 2048 Game. Respond to arrow keys, and update score on every tile merge.",
        tech: "HTML, CSS, Javascript"
    },
    {
        img: ReliableAILandingPage,
        liveLink: "https://bit.ly/3xvdcX3",
        title: "Reliable AI Landing Page",
        repoLink: "",
        desc: "Crafted landing page for the product website, effectively communicating the value and features of the software to potential users.",
        tech: "UI/UX Design, Figma",
    },
    {
        img: todoList,
        liveLink: "https://muskanmandil.github.io/Todo-List",
        title: "To-do List",
        repoLink: "https://github.com/muskanmandil/Todo-List",
        desc: "A to-do list application where you can add your todos, tick off them, edit and delete them with beautiful UI.",
        tech: "HTML, CSS, Javascript, UI/UX Design"
    },
    {
        img: DrumKit,
        liveLink: "https://muskanmandil.github.io/Drum-Kit",
        title: "Drum Kit",
        repoLink: "https://github.com/muskanmandil/Drum-Kit",
        desc: "A Drum Kit on which you can try out your beats, accessible from your keyboard. Have fun!!",
        tech: "HTML, CSS, Javascript"
    },
    {
        img: restaurantWebsite,
        liveLink: "https://muskanmandil.github.io/Adare-Restaurant",
        title: "Restaurant Website",
        repoLink: "https://github.com/muskanmandil/Adare-Restaurant",
        desc: "Featuring a fictional Restaurant with Google Maps integrated with theIr location.",
        tech: "HTML, CSS"
    },
    {
        img: bikeRepairWebsite,
        liveLink: "https://muskanmandil.github.io/Roar-Bikes-Repair-Website",
        title: "Bike Repair Website",
        repoLink: "https://github.com/muskanmandil/Roar-Bikes-Repair-Website",
        desc: "A static website for a Bike Repair Shop containing all their information, services and how to contact them.",
        tech: "HTML, CSS"
    },
    {
        img: Calculator,
        liveLink: "https://muskanmandil.github.io/Calculator",
        title: "Calculator",
        repoLink: "https://github.com/muskanmandil/Calculator",
        desc: "Basic Calculator app made with inline javascript. It does all the basic operations of a calculator with beautiful UI.",
        tech: "HTML, CSS, Javascript"
    }
]

export default all_projects;